import { PlainTooltip } from "./PlainTooltip";

import { SWReactIcons } from "@similarweb/icons";
import styled from "styled-components";

const IconContainer = styled.span`
    display: inline-block;
`;
const InfoTip = ({ text }: { text: string }) => {
    return (
        <PlainTooltip text={text}>
            <IconContainer>
                <SWReactIcons
                    iconName="info"
                    size="xs"
                />
            </IconContainer>
        </PlainTooltip>
    );
};

export default InfoTip;
